/**
 * Takes an HTMLElement, checks its vertical positioning within the parent
 * and scrolls it into view if it is fully or partially visible.
 * @param element
 */
export const scrollElementIntoViewIfNeeded = (element: HTMLElement) => {
  const parent = element.parentElement;
  if (!(parent instanceof HTMLElement)) {
    return;
  }
  const refBounds = element.getBoundingClientRect();
  const parentBounds = parent.getBoundingClientRect();
  const optionTop = refBounds.top - parentBounds.top + parent.scrollTop;
  const optionBottom = optionTop + refBounds.height;
  const parentTop = parent.scrollTop;
  const parentBottom = parentTop + parentBounds.height;
  const isFullyVisible = optionTop >= parentTop && optionBottom <= parentBottom;
  if (isFullyVisible) {
    return;
  }
  element.scrollIntoView(parentBottom > optionBottom);
};
